import { ClientDataRequest } from '@blk/aw-bff-typescript-models';

export const generateSensitiveDataFetchRequestPayload = (
  originalPayload: ClientDataRequest,
  isStrictMode: boolean
): ClientDataRequest => {
  const payloadWithoutUserIdentity: ClientDataRequest = { ...originalPayload };
  delete payloadWithoutUserIdentity.userIdentity;
  const finalPayload: ClientDataRequest = isStrictMode
    ? { externalIds: payloadWithoutUserIdentity.externalIds }
    : { ...payloadWithoutUserIdentity };
  // If the userIdentity is not empty, it will be added to the final payload. This is different from sensitive data search.
  if (originalPayload.userIdentity !== undefined && originalPayload.userIdentity.length > 0) {
    finalPayload.userIdentity = [...originalPayload.userIdentity];
  }
  return finalPayload;
};
